import { Component, OnInit } from '@angular/core';

import { IOffers, IStrapiDocument } from 'src/app/interfaces/strapi';
import { PageComponent } from 'src/app/shared/components/page/page.component';

import { Meta, Title } from '@angular/platform-browser';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-top-offers',
    templateUrl: './top-offers.component.html',
    styleUrls: ['./top-offers.component.scss'],
    imports: [NgIf, NgFor],
})
export class TopOffersPageComponent extends PageComponent implements OnInit {
  public isLoading: boolean = false;

  public override pageData: IOffers = <IOffers>{};

  constructor(
    protected override readonly titleService: Title,
    protected override readonly metaService: Meta,
    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.strapi
      .getDocumentsByType('offer', {
        populate: {
          cards: { populate: ['icon'] },
        },
      })
      .subscribe((data: IStrapiDocument<IOffers>) => {
        this.parsePageData(data.data.attributes);
        this.isLoading = false;
      });
  }

  protected override parsePageData(page: IOffers): void {
    super.parsePageData(page);

    this.pageData = page;
  }
}
